import { render, staticRenderFns } from "./Correction.vue?vue&type=template&id=2eb93182&scoped=true&"
import script from "./Correction.vue?vue&type=script&lang=js&"
export * from "./Correction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb93182",
  null
  
)

export default component.exports